import React, { useEffect, useState } from 'react'
import './style.scss'
import { CalendarDays, ChevronLeft, IndianRupee, Upload } from 'lucide-react'
import { useSelector } from 'react-redux'
import CameraCapture from '../../components/cameraOption';
import { createSalesAdvance } from '../../services/salesAdvanceOrder';
import { toast } from 'react-toastify';
import CustomButton from '../../components/customButton';
import { useNavigate } from 'react-router-dom';

function SalesOrderAdvanced() {
  const userData = useSelector((state) => state.user);
  const agentData = useSelector((state) => state.agent);
  console.log(userData, "userData");
const navigate = useNavigate()
  const [formData, setFormData] = useState({
    advanceType: '',
    advanceCategory: '',
    rateType: 'Fixed',
    schemeName: '',
    schemeAmount: '',
    dueDate: '',
    orderAmount: '',
    advanceAmount: '',
    orderMetalWeight: '',
    validityDays: '',
    billingDueDate: '',
    parent_ownership: ''
  });
  const [loading, setLoading] = useState(false);
  const handleChange = (e) => {

    const { name, value } = e.target;
    console.log(name, value);
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const validityMapping = {
    10: 10,
    20: 20,
    30: 30,
    40: 40,
    50: 50,
    60: 60,
    70: 70,
    80: 80,
    90: 90,
    100: 90
  };

  useEffect(() => {
    const order = parseFloat(formData.orderAmount);
    const advance = parseFloat(formData.advanceAmount);

    if (!isNaN(order) && !isNaN(advance) && order > 0) {
      const percentage = Math.round((advance / order) * 100);
      const matchedPercentage = Object.keys(validityMapping)
        .map(Number)
        .reverse()
        .find(p => percentage >= p);

      if (matchedPercentage) {
        const validity = validityMapping[matchedPercentage];

        // Calculate billing due date
        const today = new Date();
        const billingDate = new Date(today.setDate(today.getDate() + validity));
        const formattedDate = billingDate.toISOString().split('T')[0]; // YYYY-MM-DD

        setFormData(prev => ({
          ...prev,
          validityDays: validity.toString(),
          billingDueDate: formattedDate
        }));
      } else {
        setFormData(prev => ({
          ...prev,
          validityDays: '',
          billingDueDate: ''
        }));
      }
    }
  }, [formData.orderAmount, formData.advanceAmount]);


  const handleSubmit = async () => {

if (!userData?.isUser) {
      toast.warning("Please log in with a valid customer ID before continuing.");
      return
    }

    const requiredFields = [
      { name: "advanceType", label: "Advance Type" },
      { name: "advanceCategory", label: "Advance Category" },
      { name: "rateType", label: "Rate Type" },
      { name: "schemeName", label: "Scheme Name" },
      { name: "schemeAmount", label: "Scheme Amount" },
      { name: "dueDate", label: "Due Date" },
      { name: "orderAmount", label: "Order Amount" },
      { name: "advanceAmount", label: "Advance Amount" },
      { name: "orderMetalWeight", label: "Order Metal Weight" },
      { name: "validityDays", label: "Validity Days" },
      { name: "billingDueDate", label: "Billing Due Date" }
    ];

    for (let field of requiredFields) {
      if (!formData[field.name]) {
        toast.error(`Please fill the "${field.label}" field.`);
        return;
      }
    }

    const orderAmount = parseFloat(formData.orderAmount);
    const advanceAmount = parseFloat(formData.advanceAmount);
    const schemeAmount = parseFloat(formData.schemeAmount);

    if ([orderAmount, advanceAmount, schemeAmount].some(isNaN)) {
      toast.error("Scheme, order, and advance amounts must be valid numbers.");
      return;
    }

    if (advanceAmount > orderAmount) {
      toast.error("Advance amount cannot be more than order amount.");
      return;
    }

    const advancePercentage = (advanceAmount / orderAmount) * 100;
    if (advancePercentage < 10) {
      toast.error("Advance amount must be at least 10% of the order amount.");
      return;
    }

    const payload = {
      customer: userData?.userName,
      company: agentData?.storeName,
      status: "",
      posting_date: new Date(),
      order_metal_purity_wt: formData?.orderMetalWeight,
      store: agentData?.storeCode,
      advance_type: formData?.advanceType,
      advance_amount: formData?.advanceAmount,
      order_amount: formData?.orderAmount,
      advance_category: formData?.advanceCategory,
      rate_type: formData?.rateType,
      scheme_name: formData?.schemeName,
      due_date: formData?.dueDate,
      scheme_amount: formData?.schemeAmount,
      validity_days: formData?.validityDays,
      customer_address: userData?.address,
      terms: "",
      parent_ownership: formData?.parent_ownership
    };

    try {
      setLoading(true);
      const response = await createSalesAdvance(payload);
      toast.success("Sales advance created successfully!");
      setFormData({
        advanceType: '',
        advanceCategory: '',
        rateType: '',
        schemeName: '',
        schemeAmount: '',
        dueDate: '',
        orderAmount: '',
        advanceAmount: '',
        orderMetalWeight: '',
        validityDays: '',
        billingDueDate: '',
        parent_ownership: ''
      });
      console.log("Response:", response);
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="">

      <div className="gold-advance-form">
        <div className="" style={{
          marginBottom: "20px"
        }}>

          <div className="" style={{
            display: "flex",
            alignItems: "center",
            gap: "10px"
          }}>
            <ChevronLeft style={{
              cursor:"pointer"
            }} onClick={()=>{
              navigate(-1)
            }} />
            <h2>Sales Order Advanced</h2>
          </div>
        </div>
        {/* Customer Information */}
        <div className="section">
          <h3>Customer Information</h3>
          <div className="row">
            <div className="field"><label>Customer Name</label><input type="text" value={userData?.userName} readOnly /></div>
            <div className="field"><label>Phone Number</label><input type="text" value={`+91 ${userData?.phone}`} readOnly /></div>
            <div className="field"><label>Parent Ownership</label>
              <select name="parent_ownership" value={formData.parent_ownership} onChange={handleChange}>
                <option value="Candere">Candere</option>
                <option value="Kalyan">Kalyan</option>
              </select>
            </div>
          </div>
        </div>

        {/* Advance Details */}
        <div className="section">
          <h3>Advance Details</h3>
          <div className="row">
            <div className="field">
              <label>Advance Type</label>
              <select name="advanceType" value={formData.advanceType} onChange={handleChange}>
                <option value="Full Payment">Full Payment</option>
                <option value="Partial">Partial</option>
              </select>
            </div>

            <div className="field">
              <label>Advance Category</label>
              <select name="advanceCategory" value={formData.advanceCategory} onChange={handleChange}>
                <option value="Wedding Purchase">Wedding Purchase</option>
                <option value="Investment">Investment</option>
              </select>
            </div>

            <div className="field rate-type">
              <label>Rate Type</label>
              <div className="checkboxes" style={{ marginTop: "10px" }}>
                <label><input type="radio" name="rateType" value="Fixed" checked={formData.rateType === 'Fixed'} onChange={handleChange} /> Fixed</label>
                <label><input type="radio" name="rateType" value="Current Market" checked={formData.rateType === 'Current Market'} onChange={handleChange} /> Current Market</label>
                <label><input type="radio" name="rateType" value="Scheme Based" checked={formData.rateType === 'Scheme Based'} onChange={handleChange} /> Scheme Based</label>
              </div>
            </div>
          </div>
        </div>

        {/* Reference Info */}
        <div className="section">
          <h3>Advance Reference Information</h3>
          <div className="row">
            <div className="field">
              <label>Scheme Name</label>
              <input name="schemeName" value={formData.schemeName} onChange={handleChange} />
            </div>
            <div className="field">
              <label>Scheme Amount</label>
              <input name="schemeAmount" value={formData.schemeAmount} onChange={handleChange} />
            </div>
            <div className="field">
              <label>Due Date</label>
              <input type="date" name="dueDate" value={formData.dueDate} onChange={handleChange} />
            </div>
          </div>
        </div>

        {/* Summary */}
        <div className="section">
          <h3>Summary</h3>
          <div className="row">
            <div className="field">
              <label>Order Amount</label>
              <div className="input-with-icon">
                <input
                  type="number"
                  placeholder='-'
                  ty
                  name="orderAmount" style={{
                    color: "green"
                  }} value={formData.orderAmount} onChange={handleChange} />
                <IndianRupee className="input-icon" color='green' />
              </div>
            </div>
            <div className="field">
              <label>Advance Amount</label>
              <div className="input-with-icon">
                <input
                  placeholder='-'

                  type="number" name="advanceAmount" value={formData.advanceAmount} onChange={handleChange} style={{
                    color: "#D97706"
                  }} />
                <IndianRupee className="input-icon" color="#D97706" />
              </div>
            </div>
            <div className="field">
              <label>Order Metal Weight</label>
              <div className="input-with-icon">
                <input type="number" name="orderMetalWeight" placeholder='-' value={formData.orderMetalWeight} onChange={handleChange} style={{
                  color: "blue"
                }} />
                <p className="input-icon"  >Gram</p>
              </div>
            </div>
            <div className="field">
              <label>Validity Days</label>
              <div className="input-with-icon">
                <input readOnly name="validityDays" value={formData.validityDays} placeholder='-' onChange={handleChange} />
                <CalendarDays className="input-icon" />
              </div>
            </div>
            <div className="field">
              <label>Billing Due Date</label>
              <div className="input-with-icon">
                <input name="billingDueDate" value={formData.billingDueDate} readOnly placeholder='-' />
                {/* <input type="date" name="billingDueDate" value={formData.billingDueDate} onChange={handleChange} /> */}
              </div>
            </div>


          </div>
          <div className="" style={{ display: "flex", justifyContent: "end", alignItems: "center", padding: "20px" }}>
            <CustomButton
              icon={<Upload />}
              onClick={() => {
                handleSubmit()
              }} className="btn btn-primary" style={{ marginTop: "20px", marginBottom: "20px" }}>Submit</CustomButton>
          </div>
        </div>

        {/* <CameraCapture /> */}
      </div>


    </div>

  )
}

export default SalesOrderAdvanced
